import React from 'react';
import {Stack} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

function EmptyState() {
  return (
    <Stack
      paddingY="64px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Body size="lg" color={designSystemToken('semantic.fg.tertiary')}>
        {translate('No recent projects yet.')}
      </Body>
    </Stack>
  );
}

export default EmptyState;
